export const globalDialogState = () => ({
    globalDialog: false,
    globalDialogTitle: '',
    globalDialogText: '',
    globalDialogAction: [],
    primaryAction: [],
    globalDialogTaskId: null,
    globalDialogHash: null,
    globalDialogId: 0,
    globalDialogQueue: [],
    options: null
})

const isSessionWarning = dialog => dialog.dialogAction.some(action => action === 'logout' || action === 'reload')
const sameWarning = (first, second) =>
    isSessionWarning(first) &&
    first.dialogTitle === second.dialogTitle &&
    first.dialogText === second.dialogText &&
    first.dialogAction.join() === second.dialogAction.join()

const activate = (state, dialog) => {
    state.globalDialogId += 1
    state.globalDialog = true
    state.globalDialogTitle = dialog.dialogTitle
    state.globalDialogText = dialog.dialogText
    state.globalDialogAction = dialog.dialogAction
    state.primaryAction = dialog.primaryAction
    state.globalDialogTaskId = dialog.globalDialogTaskId
    state.globalDialogHash = dialog.hash
    state.options = dialog.options
}

export function showGlobalDialog(state, { dialogTitle, dialogText, dialogAction, primaryAction = [], globalDialogTaskId, options, hash }) {
    if (!Array.isArray(dialogAction)) {
        console.error('dialogActions should be an array')
        return
    }
    const dialog = {
        dialogTitle,
        dialogText,
        dialogAction: [...dialogAction],
        primaryAction: Array.isArray(primaryAction) ? [...primaryAction] : [],
        globalDialogTaskId,
        options,
        hash
    }
    if (!state.globalDialog) {
        activate(state, dialog)
        return
    }
    const active = { dialogTitle: state.globalDialogTitle, dialogText: state.globalDialogText, dialogAction: state.globalDialogAction }
    if (isSessionWarning(dialog)) {
        if (sameWarning(active, dialog) || state.globalDialogQueue.some(pending => sameWarning(pending, dialog))) return
        const index = state.globalDialogQueue.findIndex(pending => !isSessionWarning(pending))
        state.globalDialogQueue.splice(index < 0 ? state.globalDialogQueue.length : index, 0, dialog)
    } else {
        state.globalDialogQueue.push(dialog)
    }
}

export function hideGlobalDialog(state, id) {
    if (id !== undefined && id !== state.globalDialogId) return
    const next = state.globalDialogQueue.shift()
    if (next) {
        activate(state, next)
        return
    }
    state.globalDialog = false
    state.primaryAction = []
    state.globalDialogTaskId = null
    state.globalDialogHash = null
    state.options = null
}

export function clearGlobalDialogQueue(state) {
    state.globalDialogQueue = []
}
